if (!customElements.get('dbtfy-upsell-popup')) {
  customElements.define(
    'dbtfy-upsell-popup',
    class DbtfyUpsellPopup extends HTMLElement {
      constructor() {
        super();
        this.opener = this.querySelector('modal-opener');
        this.blockSettings = [];
        this.querySelectorAll('[data-upsell-popup-block-settings]').forEach((script) => {
          this.blockSettings.push(JSON.parse(script.innerHTML));
        });
      }

      cartUpdateUnsubscriber = undefined;

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.cartUpdate.bind(this));
      }

      cartUpdate(e) {
        if (e.source === 'product-form') {
          const quickAddModal = document.querySelector(this.opener.dataset.modal);
          if (quickAddModal.hasAttribute('open')) return;
          const cartData = e.cartData;
          let productTriggers = this.blockSettings.filter((setting) => setting.productTrigger === cartData.handle);
          if (!productTriggers.length)
            productTriggers = this.blockSettings.filter(
              (setting) => setting.productHandles.indexOf(cartData.handle) !== -1
            );
          if (!productTriggers.length)
            productTriggers = this.blockSettings.filter(
              (setting) => setting.productHandles.length === 0 && setting.productTrigger === ''
            );
          if (!productTriggers.length) return;

          Debutify.hideCartDrawer();
          this.initModal(productTriggers[0]);
        }
      }

      initModal(settings) {
        const button = this.opener.querySelector('button');
        button.setAttribute('data-product-url', `/products/${settings.productOffer}`);
        button.click();
        document.body.addEventListener(
          'modalClosed',
          () => {
            Debutify.showCartDrawer();
          },
          { once: true }
        );
      }
    }
  );
}
